export default Object.freeze({
  SERVER_LIST: ['USUAL', 'FISHEYE', 'PIP'],
  SERVER_TYPE: {
    USUAL: 0,
    FISHEYE: 1,
    PIP: 2,
  },
});
